// Промо-модалка «Битвы с AI Claude Opus» в главном меню: не чаще раза за
// игровой день (getGameDayKey). Отметка — ключ дня последнего закрытия в
// localStorage, а не в профиле: промо локально для устройства, как и
// суточные приглашения в матчи (см. dailyPromoStorage). Сравниваем именно
// день, а не 24 часа от показа: матч каждый вечер, и вчерашнее закрытие в
// 22:00 не должно прятать сегодняшнее приглашение в 20:55
export const AI_MATCH_PROMO_SHOWN_DAY_KEY_STORAGE_KEY = 'aiMatchPromoShownDayKey';

/**
 * Пора ли показывать промо в игровой день dayKey: в этот день его еще не
 * закрывали. Недоступный localStorage (Safari в приватном режиме) — не повод
 * молчать, показываем как при отсутствии записи.
 *
 * @param {string|null} dayKey - getGameDayKey(время сервера)
 * @returns {boolean}
 */
export const checkIfAiMatchPromoDue = (dayKey) => {
  try {
    return window.localStorage.getItem(AI_MATCH_PROMO_SHOWN_DAY_KEY_STORAGE_KEY) !== dayKey;
  } catch (e) {
    return true;
  }
};

/**
 * Отметить показ в игровой день dayKey. Вызывается, только когда игрок сам
 * закрыл модалку (любой кнопкой): показ, который он не тронул, не считается.
 *
 * @param {string|null} dayKey
 */
export const rememberAiMatchPromoShown = (dayKey) => {
  if (!dayKey) return;
  try {
    window.localStorage.setItem(AI_MATCH_PROMO_SHOWN_DAY_KEY_STORAGE_KEY, dayKey);
  } catch (e) {
    // Работаем без localStorage: промо просто покажется и в следующий заход
  }
};
